import additionalStates, { additionalStatesNames } from '@constants/values/additionalStates'

const stanDodatkowy = {
    type: 'multi-checkbox',
    name: 'stan-dodatkowy',
    options: additionalStates,
    names: additionalStatesNames,
}

export default stanDodatkowy